import React from 'react';
import { Loader2 } from 'lucide-react';

/** The API does not report progress, so display an indeterminate loading state. */
export default function SearchProgress({
  active,
  label,
}: {
  active: boolean;
  label: string;
}) {
  if (!active) return null;

  return (
    <div role="status" className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6 my-4">
      <div className="flex items-center gap-3">
        <Loader2 aria-hidden="true" className="w-5 h-5 animate-spin text-goszakup-600" />
        <p className="text-sm font-semibold text-gray-700">{label}</p>
      </div>
    </div>
  );
}
